import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import LauktiLogo from '../../assets/logos/laukti_logo.png';
import KickCovidLogo from '../../assets/logos/kickcovid_logo.png';
import { isKickCovidDomain } from '../../common/helpers';
import useStyles from './AppLogo.styles';

const AppLogo = (props) => {
  const classes = useStyles();

  if (isKickCovidDomain()) {
    return (
      <div className={classes.logoContainer}>
        <img
          className={classnames({
            [classes.kickCovidLogo]: !props.navbar,
            [classes.logoInNavbarKickcovid]: props.navbar
          })}
          src={KickCovidLogo}
          alt="KickCOVID.us"
        ></img>
      </div>
    );
  } else {
    return (
      <img
        className={classnames({ [classes.lauktiLogo]: !props.navbar, [classes.logoInNavbarLaukti]: props.navbar })}
        src={LauktiLogo}
        alt="Laukti"
      ></img>
    );
  }
};

AppLogo.propTypes = {
  navbar: PropTypes.bool
};

export default React.memo(AppLogo);
